package event

import react.FC
import react.Props
import ru.malygin.dateTime.WhatDay
import utils.logger.log

external interface EventHandlerProps: Props {
    var pushEvent: EventDate?
}

object EventHandler {
    private val eventsDate = EventDate.entries
    private val currentDate = WhatDay().open_currentDay

    val launchEventInit = FC<EventHandlerProps>{props->
        log.d("[EventHandler] initial $currentDate")
        val pushedEvent = props.pushEvent

        val cE = selectEvent()
        log.d("[EventHandler] selected event $cE")

        // добавить возможность [отключать\ включать] текущий ивент через интерфейс
        val useEvent = true
        //

        pushedEvent?.let {
            log.d("[EventHandler] pushed event $it")
            when(it){
                EventDate.NO_EVENT -> Unit
                EventDate.NEW_YEAR_ON_LAST -> EventDo.newYearEvent()
                EventDate.NEW_YEAR_ON_FIRST -> EventDo.newYearEvent()
            }
            //в любом случае//заного вкючать видимость ивентов
        }?: run {
            if(useEvent){
                when(cE){
                    EventDate.NO_EVENT -> Unit
                    EventDate.NEW_YEAR_ON_LAST -> EventDo.newYearEvent()
                    EventDate.NEW_YEAR_ON_FIRST -> EventDo.newYearEvent()
                }
            }else{
                //допустим сообщение об отключённом ивенте
                when(cE){
                    EventDate.NO_EVENT -> Unit//заного вкючать видимость ивентов
                    else-> Unit
                }
            }
        }

    }

    private fun selectEvent(

    ):EventDate{
        var cE = EventDate.NO_EVENT
        eventsDate.forEach {e->
            when{
                currentDate >= (e.dateStartAndEnd?.first ?: "00.00") && currentDate <= (e.dateStartAndEnd?.second ?: "00.00") ->{
                    cE = e
                }
                else->Unit
            }
        }
        return cE
    }
}